export default function UnauthorizedWarning() {
  return (
    <div data-testid="unauthorized-warning">You are not authorized to use this application.</div>
  );
}
